import * as React from 'react';
const SvgLinesIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none" {...props}>
    <g clipPath="url(#LinesIcon_svg__a)">
      <path fill="#000" d="M4.002 9h16v2h-16V9Zm0 4h16v2h-16v-2Z" />
    </g>
    <defs>
      <clipPath id="LinesIcon_svg__a">
        <path fill="#fff" d="M.002 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLinesIcon;
